export const HEALTH_ANALYSIS_CONSTANTS = {
  太阳: ["头", "眼", "心脏"],
  武曲: ["鼻", "肺", "骨"],
  巨门: ["口", "肠"],
  天同: ["耳", "膀胱"],
  廉贞: ["血液", "生殖器", "神经系统"],
  太阴: ["肝脏"],
  贪狼: ["肝脏", "肾", "生殖器", "筋骨"],
  天机: ["心脏", "手", "神经系统", "脚"],
  紫微: ["胃"],
  天府: ["胃"],
  天相: ["膝盖"],
  七杀: ["肠"],
  文昌: ["神经系统", "关节"],
  文曲: ["神经系统", "关节"],
  天梁: ["关节"],
  破军: ["肠"],
} as const;